import React, { useContext, useMemo } from "react";
import Map from "../Maps/Map";
import Positions from "../Positions/Positions";
import ManageZoom from "../Helpers/ManageZoom/ManageZoom";
import LeafletGeocoder from "../Maps/MapGeoCoder";
import ObjectFocus from "../LiveTracking/ObjectSelected/ObjectDraggable/ObjectFocus";
import { Helmet } from "react-helmet";
import TrackedVehicles from "./VehiclesSection/TrackedVehicles";
import TrackedSelectedVehicle from "./VehiclesSection/TrackedSelectedVehicle/TrackedSelectedVehicle";
import { livetrackingcontext } from "../../context/LiveTrackingContext";
import { popupcontext } from "../../context/Popupscontext";
import { useSelector } from "react-redux";
import Geofences from "../Geofences/Geofences";

export default function LiveTrackingV2() {
	const { objectselect } = useContext(popupcontext);
	let { trackingType, shownData, selectedId, imei, setImei } =
		useContext(livetrackingcontext);
	const positions = useSelector((state) => state.webSocket.positions);
	const devices = useSelector((state) => state.webSocket.devices);
	const TableshownData = useMemo(() => {
		return Object.values(shownData).flat();
	}, [shownData]);
	console.log("Positions", positions, "Devices", devices);
	console.log("SelectedId", selectedId);
	return (
		<div>
			<Helmet>
				<title>Live Tracking</title>
				<meta name="description" content="Live Tracking" />
			</Helmet>
			<Map minZoom={5} maxZoom={18} zoomAnimation={true} zoomSnap={0.1}>
				<Positions />
				<ManageZoom>
					<LeafletGeocoder />
					<TrackedVehicles />
					<Geofences />

					{objectselect && imei && (
						<TrackedSelectedVehicle
							imei={imei}
							setimei={setImei}
							device={devices?.find((item) => item.id === selectedId)}
							position={positions?.find((pos) => pos.deviceId === selectedId)}
							values={TableshownData?.find((item) => item.id === selectedId)}
							type={trackingType}
						/>
					)}
					<ObjectFocus />
				</ManageZoom>
			</Map>
		</div>
	);
}
